import React, { useState, Fragment } from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import moment from "moment";
import OpenInNewIcon from "mdi-react/OpenInNewIcon";
import {
  _capitalizeText,
  _shouldShow,
  _getBuildingPhotos,
  _formatPrice,
  _formatNumber,
  _getBuildingURL,
  _checkBuildingAltAdr,
  _showAltAdrs,
  _getCrossStreet,
  _getOccupancy,
  _getProjectType,
  _formatNum,
  _formatDimension,
  _getServiceLevel,
} from "../../../../../shared/helpers/utils";
import TaxAbatement from "../../../../../shared/components/TaxAbatement";
import { Grid } from "@material-ui/core";
import FeatureIcon from "mdi-react/CheckCircleOutlineIcon";
import NoFeatureIcon from "mdi-react/CheckboxBlankCircleOutlineIcon";
import LinkIcon from "mdi-react/InformationOutlineIcon";
import MapIcon from "mdi-react/MapMarkerCircleIcon";
import { Link } from "react-router-dom";

const MainInfoUnits = (props) => {
  const { buildingRes, hood, boro } = props;
  let first_close_year = buildingRes.first_closing_date
    ? parseInt(moment(buildingRes.first_closing_date).format("YYYY"))
    : 0;

  if (first_close_year <= 1970) {
    first_close_year = 9999;
  }
  
  let renovated_year = Math.max(buildingRes.year_converted, buildingRes.year_altered_1, buildingRes.year_altered_2);

  if (
    !buildingRes.pipeline_total_units_proposed &&
    buildingRes.pipeline_dwelling_units_proposed
  ) {
    buildingRes.pipeline_total_units_proposed =
      buildingRes.pipeline_dwelling_units_proposed;
  }
  let bblDisplay = false;
  
  let buildingOwnershipType =
    buildingRes.ownership_type && _shouldShow(buildingRes.ownership_type)
      ? buildingRes.ownership_type.toString().toLowerCase().trim()
      : false;
  
  if (buildingRes.block && buildingRes.block > 0 && buildingRes.lot > 0) {
    let borough_code = buildingRes.borough_code;
    let block = buildingRes.block;
    let lot = buildingRes.lot;
    if (buildingOwnershipType && !buildingOwnershipType.includes("condo")) {
      bblDisplay = (
        <Fragment>
          <div>
            {block} | {lot}{" "}
            <Link
              to={{
                pathname: `https://a836-acris.nyc.gov/bblsearch/bblsearch.asp?borough=${borough_code}&block=${block}&lot=${lot}`,
              }}
              target="_blank"
              replace
              className="fa fa-external-link"
            >
              ACRIS <i aria-hidden="true" />
            </Link>
          </div>
        </Fragment>
      );
    } else {
      bblDisplay = (
        <Fragment>
          {block} | {lot}
        </Fragment>
      );
    }
  }
  return (
    <Fragment>
      <div className="product-summary__info project-product-summary_info">
        <div>
         

          {buildingRes && _getCrossStreet(buildingRes) && (
            <p
              className={`${
                _getCrossStreet(buildingRes) ? "has-info" : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Cross Streets:
              <span className="project_details-text_style">
                <Fragment>{_getCrossStreet(buildingRes)}</Fragment>
              </span>
            </p>
          )}
          {hood && (
            <p className={`${hood ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Neighborhood:
              <span className="project_details-text_style">
                <Fragment>
                  {hood === "nyc" ? (
                    "NYC"
                  ) : (
                    <span className="u_link">{_capitalizeText(hood)}</span>
                  )}
                </Fragment>
              </span>
            </p>
          )}
          
          {boro && (
            <p className={`${boro ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Borough:
              <span className="project_details-text_style">
                <Fragment>
                  {boro === "new york" ? (
                    "New York"
                  ) : (
                    <span className="u_link">{_capitalizeText(boro)}</span>
                  )}
                </Fragment>
              </span>
            </p>
          )}
          {buildingRes && buildingRes.zip && (
            <p className={`${buildingRes.zip ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Zip Code:
              <span className="project_details-text_style">
                <Fragment>{buildingRes.zip}</Fragment>
              </span>
            </p>
          )}
          {bblDisplay && (
            <p
              className={`${bblDisplay ? "has-info d-flex" : "no-info d-flex"}`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Block & Lot:
              <span className="project_details-text_style">{bblDisplay}</span>
            </p>
          )}
          {(buildingRes.historic_district_name || buildingRes.historic_district) && (
            <p className="has-info">
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Historic District:
              <span className="project_details-text_style">
                <Fragment>
                  <span className="u_link">{_capitalizeText(buildingRes.historic_district_name || buildingRes.historic_district)}</span>
                </Fragment>
              </span>
            </p>
          )}
          <p className={`${buildingOwnershipType ? "has-info" : "no-info"}`}>
            <FeatureIcon className="has-info" />
            <NoFeatureIcon className="no-info" />
            Building Type:
            <span className="project_details-text_style">
              {buildingOwnershipType ? (
                <Fragment>{_capitalizeText(buildingOwnershipType)}</Fragment>
              ) : (
                <span className="no-info">--</span>
              )}
            </span>
          </p>
          
          {buildingRes.year_built && _shouldShow(buildingRes.year_built) ? (
            <p className={`${buildingRes.year_built ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Year Built:
              <span className="project_details-text_style">
                {buildingRes.year_built ? buildingRes.year_built : "--"}
              </span>
            </p>
          ) : null}
          {renovated_year && _shouldShow(renovated_year) && renovated_year > buildingRes.year_built  ? (
            <p className={`${buildingRes.year_converted ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Year Renovated:
              <span className="project_details-text_style">
                {renovated_year ? renovated_year : "--"}
              </span>
            </p>
          ) : null}

         
        </div>
      </div>
    </Fragment>
  );
};



const MainInfoAreaNew = (props) => {
  const { buildingRes, property } = props;
  let first_close_year = buildingRes.first_closing_date
    ? parseInt(moment(buildingRes.first_closing_date).format("YYYY"))
    : 0;

  if (first_close_year <= 1970) {
    first_close_year = 9999;
  }
  return (
    <Fragment>
      <div className="product-summary__info project-product-summary_info">
        <div>
          {buildingRes &&
            buildingRes.total_floors &&
            _shouldShow(buildingRes.total_floors) && (
              <p
                className={`${
                  buildingRes.total_floors ? "has-info" : "no-info"
                }`}
              >
                <FeatureIcon className="has-info" />
                <NoFeatureIcon className="no-info" />
                Floors:
                <span className="project_details-text_style">
                  {buildingRes.total_floors
                    ? _formatNum(buildingRes.total_floors) + " floors"
                    : "--"}
                </span>
              </p>
            )}
          {buildingRes.residential_units > 0 && _shouldShow(buildingRes.residential_units) && (
            <p className={`has-info`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Residential Units:
              <span className="project_details-text_style">
                {_formatNum(buildingRes.residential_units)} units
              </span>
            </p>
          )}
          {buildingRes.number_of_buildings > 1 &&
            <Fragment>
            <p
              className={`${
                buildingRes &&
                buildingRes.residential_units &&
                _shouldShow(buildingRes.residential_units)
                  ? "has-info"
                  : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Complex:
              <span className="project_details-text_style">
                {buildingRes &&
                buildingRes.number_of_buildings &&
                _shouldShow(buildingRes.number_of_buildings) ? (
                  <Fragment>
                    {_formatNum(buildingRes.number_of_buildings)} buildings
                  </Fragment>
                ) : (
                  <span className="no-info">--</span>
                )}
              </span>
            </p>
            </Fragment>}
          
          {buildingRes.building_frontage && _shouldShow(buildingRes.building_frontage) ? (
            <p className={`${buildingRes.building_frontage ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Building Dimensions:
              <span className="project_details-text_style">
               <Fragment>
                 {buildingRes.building_frontage &&
                 buildingRes.building_frontage > 1
                   ? _formatDimension(buildingRes.building_frontage)
                   : "--"}{" "}
                 ft (W) x{" "}
                 {buildingRes.building_depth &&
                 buildingRes.building_depth > 1
                   ? _formatDimension(buildingRes.building_depth)
                   : "--"}{" "}
                 ft (D)
               </Fragment>
              </span>
            </p>
          ) : null}
          {buildingRes.sq_ft && _shouldShow(buildingRes.sq_ft) ? (
            <p className={`${buildingRes.sq_ft ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Building Floor Area:
              <span className="project_details-text_style">
                <Fragment>
                  {buildingRes.sq_ft
                    ? _formatNum(buildingRes.sq_ft) + " sqft"
                    : "--"}
                </Fragment>
              </span>
            </p>
          ) : null}
          {property.sq_ft && _shouldShow(property.sq_ft) ? (
            <p className={`${property.sq_ft ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Building Total Area:
              <span className="project_details-text_style">
                <Fragment>
                  {property.sq_ft
                    ? _formatNum(property.sq_ft) + " sqft"
                    : "--"}
                </Fragment>
              </span>
            </p>
          ) : null}
          
          
          {buildingRes.lot_frontage ? (
            <p className={`${buildingRes.lot_frontage ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Lot Dimensions:
              <span className="project_details-text_style">
                <Fragment>
                  {buildingRes.lot_frontage &&
                  buildingRes.lot_frontage > 1
                    ? _formatDimension(buildingRes.lot_frontage)
                    : "--"}{" "}
                  ft (W) x{" "}
                  {buildingRes.lot_depth &&
                  buildingRes.lot_depth > 1
                    ? _formatDimension(buildingRes.lot_depth)
                    : "--"}{" "}
                  ft (D)
                </Fragment>
              </span>
            </p>
          ) : null}
          {buildingRes.lot_area ? (
            <p className={`${buildingRes.lot_area ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Lot Area:
              <span className="project_details-text_style">
                <Fragment>
                  {buildingRes.lot_area
                    ? _formatNum(buildingRes.lot_area) + " sqft"
                    : "--"}
                </Fragment>
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

const buildingResCard = (props) => {
  const { buildingRes } = props;

  let images = _getBuildingPhotos(buildingRes);

  if (images && images.length > 0) {
    images = images.map((image) => {
      return { src: image };
    });
  }
  const buildingAltAdr = _checkBuildingAltAdr(buildingRes);
  return (
  
      <Card  style={{height:"auto",paddingBottom:0}}>
        <CardBody className="no-border no-padding">
          <div className="profile-card d-block">
            <Grid className="profile-card__info" container>
              <Grid item xs={12} md={6} lg={6} sm={12}>
                <MainInfoUnits {...props} />
              </Grid>
              <Grid item xs={12} md={6} lg={6} sm={12}>
                <MainInfoAreaNew {...props} />
              </Grid>
              
              
            </Grid>
          </div>
        </CardBody>
      </Card>
    
  );
};

export default buildingResCard;
